const ProfileStatusSection = () => {
  return (
    <div className="flex flex-col bg-white border rounded-xl p-5 gap-4">
      <div className="flex items-center justify-between">
        <span className="uppercase font-bold text-xs text-slate-800">
          Profile status
        </span>
        <div className="bg-green-100 text-green-800 text-xs font-bold px-2 py-1 rounded-full">
          Active
        </div>
      </div>
      <div className="w-full h-px bg-gray-200" />
      <span className="font-semibold text-light-black text-xss leading-4">
        This profile is actively matched with relevant job opportunities.
      </span>
      {/* Match strength */}
      <div className="flex flex-col gap-1.5 my-2">
        <span className="font-bold uppercase text-xs text-slate-800">
          match strength
        </span>
        <span className="font-bold text-4xl text-slate-800">92%</span>
        <div className="rounded-full overflow-hidden h-2 w-full bg-gray-200">
          <div className="bg-slate-800 h-full w-[92%]" />
        </div>
      </div>
      {/* Excellent match */}
      <div className="flex flex-col gap-2">
        <span className="font-bold text-sm text-slate-800">
          Excellent Match
        </span>
        <span className="text-xss font-semibold leading-4 text-light-black">
          Your experience and skills strongly align with your career
          aspirations.
        </span>
        <span className="font-bold text-sm text-slate-800">
          What does this mean?
        </span>
      </div>
    </div>
  );
};

export default ProfileStatusSection;
